import {
  visible
} from '../shared/stylesheets/background.css'
import {
  transitionSvg,
  resetSvg
} from './sections/map/svg-transition-manager'
import { fakeSubtitles } from './sections/video/subtitles'
import { trackAction } from "./utils/googleAnalytics"

export const observer = (sectionElements, videoElements, muteButton, shareButtons, setSectionId, byline) => {
  const options = {
    threshold: [0],
    //rootMargin: `-98% 0px -2% 0px`
  }

  const callback = (changes) => {
    changes.forEach((change, i) => {
      const {
        target,
        isIntersecting,
        intersectionRatio
      } = change

      const backgroundId = target.getAttribute('data-background-id')
      const backgroundEl = document.getElementById(backgroundId)

      if (isIntersecting) {
        setSectionId(backgroundId)
        trackAction(`LOAD_SUCCESS/${backgroundId}`)
        backgroundEl.classList.add(visible)

        if (target.getAttribute('data-share')) {
          shareButtons.classList.add(visible)
        } else {
          shareButtons.classList.remove(visible)
        }

        if (target.getAttribute('data-video-has-sound')) {
          muteButton.classList.add(visible)

        } else {
          muteButton.classList.remove(visible)
        }

        if (target.getAttribute('data-map-element')) {
          transitionSvg(target)
        }
        if (target.getAttribute('data-video-element')) {
          const bgVideo = backgroundEl.querySelector('video')
          if (target.getAttribute('data-video-subtitles') && !target.getAttribute('data-already-subtitled')) {
             fakeSubtitles(bgVideo, target.getAttribute('data-video-subtitles'))
           }
          //fakeSubtitles(bgVideo)

          bgVideo.play()
          const videoIsPlaying = !bgVideo.paused
          if (videoIsPlaying) {
            trackAction(`VIDEO_PLAYING/${backgroundId}`)
          }
        } else if (target.getAttribute('data-background-byline')) {
          //byline.classList.add(visible)
        }

      } else {
        backgroundEl.classList.remove(visible)
        if (target.getAttribute('data-map-element')) {
          resetSvg(target)
        }
        if (target.getAttribute('data-video-element')) {
          const bgVideo = backgroundEl.querySelector('video')
          bgVideo.pause()
        }
      }
    })
  }
  const observer = new IntersectionObserver(callback, options)
  observer.POLL_INTERVAL = 500
  sectionElements.forEach(sectionElement => observer.observe(sectionElement))
}



// WEBPACK FOOTER //
// ./src/client/intersection.js